export default "__VITE_ASSET__B_EL3BCa__"